
































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

// import Header from "../header/selectPageHeader/header.vue"

import Header from "@/commonComponents/header/header.vue";

import TopControllerSearchText from "./topControllerSearchText/topControllerSearchText.vue";
import TopControllerSearchSize from "./topControllerSearchSize/topControllerSearchSize.vue";
import RightController from "./rightController/rightController.vue";
import ProductCategoryComponent from "./productCategory/productCategory.vue"; //ProductCategoryだとクラス名ProductCategoryと被る
import Tutorial from "../tutorial/tutorial.vue";
import License from "../top2/mainContents/license/license.vue";

import * as def from "@/definitions";

import { Data } from "@/data/data";
import { ProductCategory } from "@/data/productCategory/productCategory";
import { Product } from "@/data/productCategory/product/product";
import { Paper } from "@/data/productCategory/product/paper/paper";
import { productSearchInfo } from "@/definitions/productSearchInfo";

import { UserAgentHelper } from "@/helper/userAgentHelper"

import Spinner from "vue-spinkit";
import { Document } from "@/model/document2/document";

import { CookieHelper } from "@/helper/cookieHelper";
import { LogHelper } from "@/helper/logHelper";

const isElement = (x: any): x is Element => x instanceof Element;

@Component({
  components: {
    Header,

    TopControllerSearchText,
    TopControllerSearchSize,
    RightController,
    ProductCategoryComponent,
    Spinner,
    Tutorial,
    License
  }
})
export default class SelectPage extends Vue {

    isTutorial = false;
    isLicense = false;

    get browser(){
        return UserAgentHelper.getBrowser()
    }

    private get currentTab() { return "/SelectPage"; }

    get rootData(): Data {
        return this.$store.getters.data;
    }

    get productCategoryList(): ProductCategory[] {
        return this.rootData.productCategoryList;
    }

    get selectedProduct(): Product {
        return this.rootData.selectedProduct;
    }

    get paperList(): Paper[] {
        return this.selectedProduct.paperList;
    }

    get selectedPaper(): Paper {
        return this.rootData.selectedPaper;
    }

    get totalCount(): number {
        return this.rootData.productTotalCount;
    }

    get paperDirection(): number {
        return this.rootData.paperDirection;
    }

    get paperRotation()
    {
        var rotate = 0;
        var direction = this.rootData.paperDirection;
        if(direction == 1) { rotate = 90; }
        else if(direction == 2) { rotate = 180; }
        else if(direction == 3) { rotate = 270; }
        return rotate;
    }

    get isLoadNewVisible(): boolean {
        return this.rootData.isLoadNewVisibleProduct;
    }

    get isLoadAllVisible(): boolean {
        return this.rootData.isLoadAllVisibleProduct;
    }

    get productSearchInfo() {
        return this.rootData.productSearchInfo;
    }

    get productSearchType() {
        return this.rootData.productSearchType;
    }

    mounted()
    {
        // すぐタブを使えるようにドキュメントを初期化する
        this.initDocument();

        if(CookieHelper.getItem("license") != true){
            this.isLicense = true;
        }
        else if(CookieHelper.getItem("selectPageTutorial") != true){
            this.isTutorial = true;
        }
    }

    private onDoCommand(command: string, parameter: any) {
        // 次の画面に移動
        if (command == "goNext") {
            this.initDocument();

            // ログ送信
            var logValue = {
                    productId : this.selectedProduct.id,
                    code : this.selectedProduct.paperList[0].code
                };
            LogHelper.sendLog("200" , logValue);

            // 画面遷移 -> テンプレートへ
            this.$router.push("/SelectTemplate");
        }
    }

    // ドキュメントを設定する
    initDocument()
    {
        // 設定した商品
        var product = this.rootData.selectedProduct;
        // 設定した用紙
        var paper = this.rootData.selectedPaper;
        // 設定した回転角
        var rotate = 0;
        var direction = this.rootData.paperDirection;
        if(direction == 1) { rotate = 90; }
        else if(direction == 2) { rotate = 180; }
        else if(direction == 3) { rotate = 270; }
        // この用紙設定でDocumentを作成する
        var document = Document.create(product, paper, rotate);
        // 1ページ目を取得する。なければ作る
        var firstPage = document.pageList.length <= 0 ? document.createNewPage() : document.pageList[0];
        if(document.pageList.length <= 0)
        {
            document.addPage(firstPage);
        }
        // 新規デザインをテンプレートなしで作成して表面のposition = 0にする
        firstPage.getSurface(false).createNewDesign(0);
        // 差し込みかどうか
        document.useInsertion = this.$store.getters.applicationState.flowMode == 1;
        // Documentを差し替える
        this.$store.dispatch("setDocument", document);

        // documentのハッシュ初期化
        document.updateHash();
    }

    decide(){
        this.onDoCommand("goNext" , null)
    }

    changeSearchProperty(value: any, propertyName: string) {
        if (propertyName == "width") {
            this.rootData.productSearchInfo.width = value;
        }
        if (propertyName == "height") {
            this.rootData.productSearchInfo.height = value;
        }
        if (propertyName == "range") {
            this.rootData.productSearchInfo.range = value;
        }
        if (propertyName == "searchWord") {
            this.rootData.productSearchInfo.searchWord = value;
        }
    }

    changeSearchType(type: string) {
        this.rootData.productSearchType = type;
    }

    changePaperDirection(direction: number) 
    {
        this.rootData.changePaperDirection(direction)

    }

    search() {
        let mainView = this.$refs.mainView;
        if (!isElement(mainView)) return;
        mainView.scrollTop = 0;
        this.rootData.createProductCategory("search");
    }

    loadNew(visibility) {
        this.$nextTick(() => {
        if (visibility) {
            this.rootData.createProductCategory("loadNew");
            }
        });
    }

    selectProduct(productId: number, productCategoryId: number) {
        // alert(1)
        this.rootData.selectProduct(productId, productCategoryId , true);
    }

    selectPaper(paperId: number) {
        this.rootData.selectPaper(paperId);
    }

    private closeLicense(){
        this.isLicense = false;
        this.isTutorial = CookieHelper.getItem("selectPageTutorial") != true;
    }
    
    private get userConfigColorStyle(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigThinColor(){
        var style = {
          backgroundColor : this.$store.getters.userConfigColors.buttonColorRgba
        };
        return style;
    }
    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }
    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }
}
